<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="template">
    <div id="drawTable">
      <div v-for="n in pixels.length" :key="n" @mouseover="fired" @mousedown="fired">
        <div class="pixel" :style="{ background: pixels[n - 1], border: grid }" :id="n"></div>
      </div>
      <Moveable class="moveable" v-bind="moveable" @drag="handleDrag" @dragStart="drag = true" @dragEnd="drag = false">
        <MenuBar class="menu" @clear="clear" @tool="changeTool" @color="changeColor" @grid="toggleGrid" />
      </Moveable>
    </div>
  </div>
</template>

<script>
import MenuBar from "./MenuBar.vue";
import Moveable from "vue-moveable";
import Service from "@/services/drawService";
import * as Sentry from "@sentry/browser";

export default {
  data() {
    return {
      color: "#d33d29",
      tool: "pen",
      pixels: Array(2025).fill("#b0bc21"),
      grid: "0.5px solid lightgray",
      moveable: {
        draggable: true,
        throttleDrag: 1,
        origin: false
      },
      currentPixelColor: "",
      drag: false,
      fillCheckedPixels: []
    };
  },
  components: {
    MenuBar,
    Moveable
  },
  methods: {
    handleDrag({ target, transform }) {
      target.style.transform = transform;
    },
    clear() {
      this.pixels = Array(2025).fill("#b0bc21");
    },
    changeTool(tool) {
      this.tool = tool;
    },
    changeColor(color) {
      this.color = color;
    },
    toggleGrid() {
      if (this.grid !== "0") {
        this.grid = "0";
      } else this.grid = "0.5px solid lightgray";
    },
    fired(event) {
      if (!this.drag && (event.buttons === 1 || event.type === "mousedown")) {
        var i = event.target.id - 1;
        switch (this.tool) {
          case "pen":
            this.changePixel(i);
            break;
          case "fill":
            this.currentPixelColor = this.pixels[i];
            this.fillCheckedPixels = [];
            this.fill(i);
            break;
          case "eraser":
            this.changePixel(i, "#b0bc21");
            break;
        }
      }
    },
    changePixel(index, color) {
      this.pixels.splice(index, 1, color || this.color);
    },
    fill(index) {
      var x = index % 45;
      var y = Math.floor(index / 45);
      if (y > 0 || y < 44) {
        if (
          this.pixels[(y + 1) * 45 + x] === this.currentPixelColor &&
          this.fillCheckedPixels.indexOf((y + 1) * 45 + x) === -1
        ) {
          this.changePixel((y + 1) * 45 + x);
          this.fillCheckedPixels.push((y + 1) * 45 + x);
          this.fill((y + 1) * 45 + x);
        }

        if (
          this.pixels[(y - 1) * 45 + x] === this.currentPixelColor &&
          this.fillCheckedPixels.indexOf((y + 1) * 45 - x) === -1
        ) {
          this.changePixel((y - 1) * 45 + x);
          this.fillCheckedPixels.push((y - 1) * 45 + x);
          this.fill((y - 1) * 45 + x);
        }
      }
      if (x > 0 && x < 44) {
        if (
          this.pixels[y * 45 + x + 1] === this.currentPixelColor &&
          this.fillCheckedPixels.indexOf(y * 45 + x + 1) === -1
        ) {
          this.changePixel(y * 45 + x + 1);
          this.fillCheckedPixels.push(y * 45 + x + 1);
          this.fill(y * 45 + x + 1);
        }
        if (
          this.pixels[y * 45 + x - 1] === this.currentPixelColor &&
          this.fillCheckedPixels.indexOf(y * 45 + x - 1) === -1
        ) {
          this.changePixel(y * 45 + x - 1);
          this.fillCheckedPixels.push(y * 45 + x - 1);
          this.fill(y * 45 + x - 1);
        }
      }
    },
    sendToAPI() {
      if (confirm("Envoyer ce camp ?")) {
        Service.getIdsForFinal(this.pixels)
          .then(Service.uploadFinal)
          .then((e) => {
            if (e.status !== 204) throw new Error(e);
            this.$bvToast.toast(`Ton camp a réussi à s'établir dans la Troposphère`, {
              title: "Oui !",
              variant: "success"
            });
          })
          .catch((e) => {
            this.$bvToast.toast(`Ton camp n'a pas réussi à s'établir dans la Troposphère`, {
              title: "Oh non !",
              variant: "danger"
            });
            Sentry.configureScope(function (user) {
              user.setUser({ id: sessionStorage.getItem("tilesId") });
              user.setTag("tilesX", sessionStorage.getItem("tilesX"));
              user.setTag("tilesY", sessionStorage.getItem("tilesY"));
              user.setTag("phase", "Send image into Cellar");
              user.setLevel("fatal");
            });
            Sentry.captureException(new Error(e));
          });
      }
    }
  }
};
</script>

<style lang="scss">
#drawTable {
  width: 540px;
  height: 540px;
}

.template {
  width: 540px;
}
.menu {
  position: relative;
  top: -510px;
  right: 20px;
  float: right;
  z-index: 5;
}
.moveable-line {
  height: 0px !important;
}
div.pixel {
  /* border: 0.5px solid lightgray; */
  height: 12px;
  width: 12px;
  float: left;
}
</style>
